function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
import Icons from './icons';
var Controller = function () {
    function Controller(player) {
        _classCallCheck(this, Controller);
        this.player = player;
        this.initPlayButton();
        this.initPlayBar();
        this.initOrderButton();
        this.initLoopButton();
        this.initDownloadButton();
        this.initMenuButton();
        if (!utils.isMobile) {
            this.initVolumeButton();
        }
        this.initMiniSwitcher();
        this.initSkipButton();
        this.initLrcButton();
    }
    _createClass(Controller, [
        {
            key: 'initPlayButton',
            value: function initPlayButton() {
                var _this = this;
                this.player.template.pic.addEventListener('click', function () {
                    _this.player.toggle();
                });
            }
        },
        {
            key: 'initPlayBar',
            value: function initPlayBar() {
                var _this2 = this;
                var thumbMove = function thumbMove(e) {
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - _this2.player.template.barWrap.getBoundingClientRect().left) / _this2.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this2.player.bar.set('played', percentage, 'width');
                    _this2.player.lrc && _this2.player.lrc.update(percentage * _this2.player.duration);
                    _this2.player.template.ptime.innerHTML = utils.secondToTime(percentage * _this2.player.duration);
                };
                var thumbUp = function thumbUp(e) {
                    document.removeEventListener(utils.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(utils.nameMap.dragMove, thumbMove);
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - _this2.player.template.barWrap.getBoundingClientRect().left) / _this2.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this2.player.bar.set('played', percentage, 'width');
                    _this2.player.seek(percentage * _this2.player.duration);
                    _this2.player.disableTimeupdate = false;
                };
                this.player.template.barWrap.addEventListener(utils.nameMap.dragStart, function () {
                    _this2.player.disableTimeupdate = true;
                    document.addEventListener(utils.nameMap.dragMove, thumbMove);
                    document.addEventListener(utils.nameMap.dragEnd, thumbUp);
                });
            }
        },
        {
            key: 'initVolumeButton',
            value: function initVolumeButton() {
                var _this3 = this;
                this.player.template.volumeButton.addEventListener('click', function () {
                    if (_this3.player.audio.muted) {
                        _this3.player.volume(_this3.player.audio.volume, true);
                    } else {
                        _this3.player.audio.muted = true;
                        _this3.player.switchVolumeIcon();
                        _this3.player.bar.set('volume', 0, 'height');
                    }
                });
                var thumbMove = function thumbMove(e) {
                    var percentage = 1 - ((e.clientY || e.changedTouches[0].clientY) - _this3.player.template.volumeBar.getBoundingClientRect().top) / _this3.player.template.volumeBar.clientHeight;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this3.player.volume(percentage);
                };
                var thumbUp = function thumbUp(e) {
                    _this3.player.template.volumeBarWrap.classList.remove('aplayer-volume-bar-wrap-active');
                    document.removeEventListener(utils.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(utils.nameMap.dragMove, thumbMove);
                    var percentage = 1 - ((e.clientY || e.changedTouches[0].clientY) - _this3.player.template.volumeBar.getBoundingClientRect().top) / _this3.player.template.volumeBar.clientHeight;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this3.player.volume(percentage);
                };
                this.player.template.volumeBarWrap.addEventListener(utils.nameMap.dragStart, function () {
                    _this3.player.template.volumeBarWrap.classList.add('aplayer-volume-bar-wrap-active');
                    document.addEventListener(utils.nameMap.dragMove, thumbMove);
                    document.addEventListener(utils.nameMap.dragEnd, thumbUp);
                });
            }
        },
        {
            key: 'initOrderButton',
            value: function initOrderButton() {
                var _this4 = this;
                this.player.template.order.addEventListener('click', function () {
                    if (_this4.player.options.order === 'list') {
                        _this4.player.options.order = 'random';
                        _this4.player.template.order.innerHTML = Icons.orderRandom;
                    } else if (_this4.player.options.order === 'random') {
                        _this4.player.options.order = 'list';
                        _this4.player.template.order.innerHTML = Icons.orderList;
                    }
                });
            }
        },
        {
            key: 'initLoopButton',
            value: function initLoopButton() {
                var _this5 = this;
                this.player.template.loop.addEventListener('click', function () {
                    if (_this5.player.list.audios.length > 1) {
                        if (_this5.player.options.loop === 'one') {
                            _this5.player.options.loop = 'none';
                            _this5.player.template.loop.innerHTML = Icons.loopNone;
                        } else if (_this5.player.options.loop === 'none') {
                            _this5.player.options.loop = 'all';
                            _this5.player.template.loop.innerHTML = Icons.loopAll;
                        } else if (_this5.player.options.loop === 'all') {
                            _this5.player.options.loop = 'one';
                            _this5.player.template.loop.innerHTML = Icons.loopOne;
                        }
                    } else {
                        if (_this5.player.options.loop === 'one' || _this5.player.options.loop === 'all') {
                            _this5.player.options.loop = 'none';
                            _this5.player.template.loop.innerHTML = Icons.loopNone;
                        } else if (_this5.player.options.loop === 'none') {
                            _this5.player.options.loop = 'all';
                            _this5.player.template.loop.innerHTML = Icons.loopAll;
                        }
                    }
                });
            }
        },
        {
            key: 'initDownloadButton',
            value: function initDownloadButton() {
                var _this6 = this;
                if (!this.player.options.download) {
                    return;
                }
                this.player.template.download.addEventListener('click', function () {
                    var audio = _this6.player.list.audios[_this6.player.list.index];
                    if (!audio || !audio.url) {
                        return;
                    }
                    _this6.downloadWithProgress(audio);
                });
            }
        },
        {
            key: 'downloadWithProgress',
            value: function downloadWithProgress(audio) {
                var self = this;
                var ext = this.getExtensionFromUrl(audio.url) || 'mp3';
                var baseName = audio.name ? audio.name.replace(/\.[^.]+$/, '') : 'audio';
                this.player.notice('正在下载...', 0, 0.8);
                fetch(audio.url, { mode: 'cors' }).then(function (response) {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    var contentLength = response.headers.get('content-length');
                    var total = contentLength ? parseInt(contentLength, 10) : 0;
                    var mimeType = response.headers.get('content-type');
                    if (!response.body) {
                        return response.blob().then(function (blob) {
                            return {
                                blob: blob,
                                mimeType: mimeType,
                                total: total
                            };
                        });
                    }
                    var reader = response.body.getReader();
                    var chunks = [];
                    var loaded = 0;
                    function readChunk() {
                        return reader.read().then(function (result) {
                            if (result.done) {
                                return {
                                    blob: new Blob(chunks),
                                    mimeType: mimeType,
                                    total: total
                                };
                            }
                            chunks.push(result.value);
                            loaded += result.value.length;
                            if (total > 0) {
                                var percent = Math.round(loaded / total * 100);
                                self.player.notice('正在下载: ' + percent + '%', 0, 0.8);
                            }
                            return readChunk();
                        });
                    }
                    return readChunk();
                }).then(function (result) {
                    var finalExt = self.getExtensionFromUrl(audio.url) || self.getExtensionFromMime(result.mimeType) || ext;
                    self.triggerDownload(result.blob, baseName, finalExt, result.mimeType);
                    self.player.notice('下载完成', 2000, 0.8);
                })['catch'](function (err) {
                    console.warn('Blob download failed, fallback to direct download:', err);
                    self.fallbackDownload(audio, baseName, ext);
                });
            }
        },
        {
            key: 'fallbackDownload',
            value: function fallbackDownload(audio, baseName, ext) {
                var a = document.createElement('a');
                a.href = audio.url;
                a.download = baseName + '.' + ext;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.player.notice('已开始下载', 2000, 0.8);
            }
        },
        {
            key: 'triggerDownload',
            value: function triggerDownload(blob, baseName, ext, mimeType) {
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                var actualExt = this.getExtensionFromMime(mimeType) || ext;
                a.download = baseName + '.' + actualExt;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
        },
        {
            key: 'getExtensionFromUrl',
            value: function getExtensionFromUrl(url) {
                var match = url.match(/\.([a-zA-Z0-9]+)(?:\?|#|$)/);
                if (match) {
                    var ext = match[1].toLowerCase();
                    var audioExts = [
                        'mp3',
                        'mp4',
                        'm4a',
                        'ogg',
                        'oga',
                        'wav',
                        'webm',
                        'flac',
                        'aac',
                        'm3u8'
                    ];
                    if (audioExts.includes(ext)) {
                        return ext;
                    }
                }
                return null;
            }
        },
        {
            key: 'getExtensionFromMime',
            value: function getExtensionFromMime(mimeType) {
                if (!mimeType)
                    return null;
                var mimeMap = {
                    'audio/mpeg': 'mp3',
                    'audio/mp3': 'mp3',
                    'audio/mp4': 'm4a',
                    'audio/x-m4a': 'm4a',
                    'audio/ogg': 'ogg',
                    'audio/wav': 'wav',
                    'audio/x-wav': 'wav',
                    'audio/webm': 'webm',
                    'audio/flac': 'flac',
                    'audio/aac': 'aac',
                    'video/mp4': 'mp4',
                    'application/x-mpegURL': 'm3u8'
                };
                return mimeMap[mimeType] || null;
            }
        },
        {
            key: 'initMenuButton',
            value: function initMenuButton() {
                var _this7 = this;
                this.player.template.menu.addEventListener('click', function () {
                    _this7.player.list.toggle();
                });
            }
        },
        {
            key: 'initMiniSwitcher',
            value: function initMiniSwitcher() {
                var _this8 = this;
                this.player.template.miniSwitcher.addEventListener('click', function () {
                    _this8.player.setMode(_this8.player.mode === 'mini' ? 'normal' : 'mini');
                });
            }
        },
        {
            key: 'initSkipButton',
            value: function initSkipButton() {
                var _this9 = this;
                this.player.template.skipBackButton.addEventListener('click', function () {
                    _this9.player.skipBack();
                });
                this.player.template.skipForwardButton.addEventListener('click', function () {
                    _this9.player.skipForward();
                });
                this.player.template.skipPlayButton.addEventListener('click', function () {
                    _this9.player.toggle();
                });
            }
        },
        {
            key: 'initLrcButton',
            value: function initLrcButton() {
                var _this10 = this;
                this.player.template.lrcButton.addEventListener('click', function () {
                    if (_this10.player.template.lrcButton.classList.contains('aplayer-icon-lrc-inactivity')) {
                        _this10.player.template.lrcButton.classList.remove('aplayer-icon-lrc-inactivity');
                        _this10.player.lrc && _this10.player.lrc.show();
                    } else {
                        _this10.player.template.lrcButton.classList.add('aplayer-icon-lrc-inactivity');
                        _this10.player.lrc && _this10.player.lrc.hide();
                    }
                });
            }
        }
    ]);
    return Controller;
}();
export default Controller;